import React from 'react';

function Modal({ children, onClose }) {
  return (
    <div className="modal">
      <div className="modal-content">
        {children}
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
      </div>
    </div>
  );
}

export default Modal;